module.exports = __webpack_public_path__ + "img/right-fuse-glow_416x270.95dcfd69.png";